import actionTypes from './actionTypes';
import { EditorialApi } from '../../api/editorial';

const api = new EditorialApi();

export const loadEditorial = () => async dispatch => {
    try{
        dispatch({type: actionTypes.LOAD_EDITORIAL_START, payload: {}});
        
        const {data} = await api.getEditorialList();

        return dispatch({type: actionTypes.LOAD_EDITORIAL_SUCCESS, payload: {data}});

    }catch(error){
        return dispatch({type: actionTypes.LOAD_EDITORIAL_FAIL, payload: {error}});
    }
};